import { render } from "./index.vue?vue&type=template&id=bb0f5016&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=bb0f5016&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=bb0f5016&lang=scss"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb0f5016"],['__file',"src/components/CampoForm/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bb0f5016"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bb0f5016', __exports__)) {
    console.log('reload')
    api.reload('bb0f5016', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=bb0f5016&scoped=true", () => {
    console.log('re-render')
    api.rerender('bb0f5016', render)
  })

}


export default __exports__